import * as React from "react";
import type { SVGProps } from "react";
const SvgCheckBlack = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <path
      stroke="#252525"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m3.75 8.75 2.62 3 6.547-7.5"
    />
  </svg>
);
export default SvgCheckBlack;
